import { Injectable } from '@angular/core';
import * as Firebase from 'firebase';
import { Roles } from '../models/Roles';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor() {
  }

  getAllPatientsForClient(uidOfClient: string) {
    const db = Firebase.firestore();
    const patients = [];
    return new Promise((resolveAllPatients) => {
      db.collection('patients').where('uidOfCreator', '==', uidOfClient).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          patients.push({
            DateOfBirth: doc.data().DateOfBirth,
            FirstName: doc.data().FirstName,
            LastName: doc.data().LastName,
            LegalCaseId: doc.data().LegalCaseId,
            caseName: doc.data().caseName,
            fileSearchQuery: doc.data().fileSearchQuery,
            files: doc.data().files,
            uidOfCreator: doc.data().uidOfCreator
          });
        });
        resolveAllPatients(patients);
      });
    });
  }

  getAllFilesForEachPatientForClient(uidOfClient: string) {
    const filesForEachPatient = [];
    return new Promise((resolveAllPatientsForClient) => {
      this.getAllPatientsForClient(uidOfClient).then((patients: any[]) => {
        patients.forEach(({caseName, files}) => {
          filesForEachPatient.push({caseName: caseName, files: files});
        });
        resolveAllPatientsForClient(filesForEachPatient);
      });
    });
  }

  getAllFilesAndCountForClient(uidOfClient: string) {
    const allFiles = [];
    return new Promise((resolveAllFiles) => {
      this.getAllFilesForEachPatientForClient(uidOfClient).then((patients: any[]) => {
        patients.forEach(({files}) => {
          allFiles.push.apply(allFiles, files);
        });
        resolveAllFiles({allFilesForClient: allFiles, countOfFiles: allFiles.length});
      });
    });
  }

  getSizeForEachFile(uidOfClient: string) {
    const storageRef = Firebase.storage().ref();
    const filesWithSize = [];
    let i = 0;
    return new Promise((resolveFilesWithSize) => {
      this.getAllFilesAndCountForClient(uidOfClient).then(({allFilesForClient}) => {
        allFilesForClient.forEach((file) => {
          const fileRef = storageRef.child(file.filePath);
          fileRef.getMetadata().then((metaData) => {
            i++;
            file.size = metaData.size;
            file.hash = metaData.md5Hash;
            filesWithSize.push(file);
            if (i === allFilesForClient.length) {
              resolveFilesWithSize(filesWithSize);
            }
          });
        });
      });
    });
  }

  getTotalFileUsageSizeForClient(uidOfClient: string) {
    let totalSizeInBytes = 0;
    return new Promise((resolveTotalSize) => {
      this.getSizeForEachFile(uidOfClient).then((allFilesWithSize: any[]) => {
        allFilesWithSize.forEach(({size}) => {
          totalSizeInBytes = totalSizeInBytes + size;
        });
        resolveTotalSize(totalSizeInBytes);
      });
    });
  }

  getNumberOfClients() {
    return new Promise((resolveClients) => {
      const allClients = [];
      const db = Firebase.firestore();
      db.collection('users').where('role', '==', Roles.client).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          allClients.push({name: doc.data().name, email: doc.data().email, uid: doc.data().uid});
        });
        resolveClients(allClients);
      });
    });
  }
}
